module.exports = __webpack_public_path__ + "img/6a78f1d.jpg";